import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography } from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },

    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },

});

const PermissionForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations } = props;
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name && errors.Name)}
                                placeholder={translations['short_name'] || "Short name"}
                                label={translations['short_name'] || "Short name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Key"
                                value={values.Key}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Key && touched.Key && errors.Key)}
                                placeholder={translations['key'] || 'Key'}
                                label={translations['key'] || 'Key'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Module"
                                value={values.Module}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Module && touched.Module && errors.Module)}
                                placeholder={translations['module'] || 'Module'}
                                label={translations['module'] || 'Module'}
                                margin={"dense"}
                                fullWidth={true}
                            />


                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={isSubmitting || loading || !(isValid && dirty)}
                                >
                                    {formSettings.ButtonSubmit.Title}
                                </Button>
                            ) : null}
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(PermissionForm);
